import React, { FC, PropsWithChildren, ReactNode } from 'react';

import clx from 'classnames';

import { Footer } from '../Footer/Footer';
import { Header, HeaderIndex } from '../Header/Header';

import styles from './Layout.module.scss';

type TIndexLayoutProps = PropsWithChildren<{
    hideSettings?: boolean;
}>;

export const SettingPageLayout: FC<PropsWithChildren<ReactNode>> = ({ children }) => {
    return (
        <div className={styles.layout__container}>
            <Header />
            {children}
        </div>
    );
};

export const IndexLayout: FC<TIndexLayoutProps> = ({ children, hideSettings }) => {
    return (
        <div className={clx(styles.layout__container, styles.layout__container_indexPage)}>
            <HeaderIndex hideSettings={hideSettings} />
            {children}
            <Footer />
        </div>
    );
};
